export default () => ({
  hidden: true,

  init() {
    this.$refs.password.addEventListener('input', () => {
      if (!this.hidden) this.sync()
    })
  },

  toggle() {
    this.hidden = !this.hidden
    if (!this.hidden) this.sync()
  },

  sync() {
    if (!this.$refs.confirmation) return
    this.$refs.confirmation.value = this.$refs.password.value
  }
})
